const calcTrend = (weeklyAvgs) => {
  const increasing = (
    (weeklyAvgs[3] > weeklyAvgs[2]) &&
    (weeklyAvgs[2] > weeklyAvgs[1])
  );
  const decreasing = (
    (weeklyAvgs[3] < weeklyAvgs[2]) &&
    (weeklyAvgs[2] < weeklyAvgs[1])
  );
  return { increasing, decreasing };
};

export const getCountryOverallTrend = (globalStatistics, countryIsoAlpha2) => {
  const weeklyCasesAvgs = globalStatistics.latestWeeklyAvgs.cases[countryIsoAlpha2];
  const weeklyDeathsAvgs = globalStatistics.latestWeeklyAvgs.deaths[countryIsoAlpha2];
  const cases = weeklyCasesAvgs ? calcTrend(weeklyCasesAvgs) : null;
  const deaths = weeklyDeathsAvgs ? calcTrend(weeklyDeathsAvgs) : null;
  return { cases, deaths };
};

export const getOverallTrends = (globalStatistics) => {
  const trends = {};
  const countriesWithCases = Object.keys(globalStatistics.latestWeeklyAvgs.cases);
  countriesWithCases.forEach((countryIsoAlpha2) => {
    trends[countryIsoAlpha2] = getCountryOverallTrend(globalStatistics, countryIsoAlpha2);
  });
  return trends;
};
